import { SOCIALS } from "@/data/content";

export const WhatsAppButton = () => {
  return (
    <a
      data-testid="whatsapp-float-btn"
      href={SOCIALS.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-6 left-6 z-50 group flex items-center gap-3"
    >
      <span className="flex items-center justify-center w-14 h-14 rounded-full bg-[#1f3a2e] shadow-lg shadow-[#1f3a2e]/25 group-hover:bg-[#25523f] transition-colors duration-300">
        <svg
          viewBox="0 0 32 32"
          width="26"
          height="26"
          fill="#faf6ef"
          aria-hidden="true"
        >
          <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.128 6.744 3.048 9.38L1.05 31.3l6.116-1.956A15.9 15.9 0 0 0 16.004 32C24.826 32 32 24.822 32 16S24.826 0 16.004 0Zm9.32 22.588c-.386 1.09-1.92 1.994-3.144 2.258-.836.178-1.928.32-5.604-1.204-4.7-1.948-7.726-6.724-7.962-7.034-.226-.31-1.9-2.53-1.9-4.826 0-2.296 1.166-3.424 1.636-3.904.386-.396.842-.576 1.324-.576.156 0 .296.008.424.014.386.016.58.038.834.646.316.762 1.086 2.658 1.178 2.852.094.194.188.456.056.766-.124.32-.234.462-.428.71-.194.248-.378.438-.572.706-.178.234-.378.486-.156.876.222.386.986 1.624 2.116 2.63 1.458 1.298 2.634 1.71 3.066 1.89.32.132.702.1.938-.156.3-.33.67-.878 1.046-1.418.266-.386.604-.434.958-.3.36.124 2.28 1.074 2.666 1.266.386.194.64.286.734.448.094.164.094.94-.292 2.03Z" />
        </svg>
      </span>
      <span className="hidden sm:block bg-[#1f3a2e] text-[#faf6ef] font-body-lux text-sm px-4 py-2 rounded-full opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
        Chat with us
      </span>
    </a>
  );
};
